import React, { useState } from "react";

const PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.ayk.turkdunyasiansiklopedisi";
const APP_STORE_URL =
  "https://apps.apple.com/tr/app/t%C3%BCrk-d%C3%BCnyas%C4%B1-ansiklopedisi/id6746564883?l=tr";

const qrSrc = (url) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=140x140&margin=8&data=${encodeURIComponent(url)}`;

const GooglePlayIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M3.6 2.3c-.4.2-.6.6-.6 1.1v17.2c0 .5.2.9.6 1.1l9.7-9.7L3.6 2.3z"
      fill="#4285F4"
    />
    <path
      d="M13.4 12l2.6-2.6 4.5 2.6c.7.4.7 1.4 0 1.8l-4.5 2.6L13.4 12z"
      fill="#FFBA00"
    />
    <path d="M13.4 12L3.6 21.7c.3.2.7.2 1.1 0L16 14.6 13.4 12z" fill="#00C853" />
    <path d="M13.4 12L16 9.4 4.7 2.3c-.4-.2-.8-.2-1.1 0L13.4 12z" fill="#FF3D00" />
  </svg>
);

const AppleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
    <path d="M16.4 12.8c0-2.1 1.7-3.1 1.8-3.2-1-1.4-2.5-1.6-3.1-1.6-1.3-.1-2.5.8-3.2.8-.7 0-1.7-.7-2.8-.7-1.4 0-2.8.9-3.5 2.2-1.5 2.6-.4 6.5 1.1 8.6.7 1 1.6 2.2 2.7 2.1 1.1-.1 1.5-.7 2.8-.7s1.7.7 2.8.7c1.2 0 1.9-1 2.6-2 .8-1.2 1.1-2.3 1.1-2.4-.1 0-2.2-.8-2.3-3.8zM14.5 6.4c.6-.7 1-1.7.9-2.7-0.9.1-1.9.6-2.5 1.3-.6.6-1.1 1.6-1 2.5 1 .1 1.9-.5 2.6-1.1z" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z" />
  </svg>
);

function MobileAppDownload() {
  const [open, setOpen] = useState(true);

  return (
    <div className={`mobile-download ${open ? "is-open" : ""}`} data-tour="mobile-app">
      {!open ? (
        <button
          type="button"
          className="mobile-download__trigger"
          onClick={() => setOpen(true)}
          aria-expanded="false"
          aria-label="Mobil uygulama indirme seçenekleri"
        >
          <PhoneIcon />
          <span>Mobil Uygulama</span>
        </button>
      ) : (
        <div className="mobile-download__panel" role="dialog" aria-label="İndirme Seçenekleri">
          <div className="mobile-download__header">
            <h3>İndirme Seçenekleri</h3>
            <button
              type="button"
              className="mobile-download__close"
              onClick={() => setOpen(false)}
              aria-label="Kapat"
            >
              ×
            </button>
          </div>

          <div className="mobile-download__cols">
            <div className="mobile-download__col">
              <a
                className="mobile-download__store-btn"
                href={PLAY_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <GooglePlayIcon />
                <span>
                  <small>GOOGLE PLAY</small>
                  <strong>&apos;den edinin</strong>
                </span>
              </a>
              <div className="mobile-download__qr">
                <img src={qrSrc(PLAY_URL)} alt="Android QR kod" width={120} height={120} />
                <p>Android için karekod (QR) ile taratın</p>
              </div>
            </div>

            <div className="mobile-download__col">
              <a
                className="mobile-download__store-btn"
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AppleIcon />
                <span>
                  <small>APP STORE</small>
                  <strong>&apos;dan indirin</strong>
                </span>
              </a>
              <div className="mobile-download__qr">
                <img
                  src={qrSrc(APP_STORE_URL)}
                  alt="iOS QR kod"
                  width={120}
                  height={120}
                />
                <p>iOS için karekod (QR) ile taratın</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MobileAppDownload;
